import { render, staticRenderFns } from "./paymentBox.vue?vue&type=template&id=3f9109f9"
import script from "./paymentBox.vue?vue&type=script&lang=js"
export * from "./paymentBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports